// Safari private mode and quota-exceeded scenarios throw on localStorage
// access. These wrappers prevent the app from crashing when that happens.

export function getItem(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export function setItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    // Silently drop — the app works without persistence.
  }
}

export function removeItem(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    // noop
  }
}
